import React from 'react';
import { Link } from 'react-router-dom';

const LandingScreen = () => (
  <main
    className="min-vh-100 d-flex flex-column bg-light"
    style={{ fontFamily: 'Inter, "Segoe UI", sans-serif', color: '#14263d' }}
  >
    {/* ============ HEADER ============ */}
    <header className="bg-white border-bottom sticky-top" style={{ borderColor: '#e7edf4' }}>
      <div className="container-xl">
        <nav className="navbar navbar-expand-md py-3">
          {/* Brand */}
          <Link to="/" className="navbar-brand d-flex align-items-center gap-2 m-0 text-decoration-none">
            <img
              src="/bhepl_logo.webp"
              alt="BHEPL"
              style={{ width: 84, height: 44, padding: 5, borderRadius: 8, background: '#193e6c', objectFit: 'contain' }}
            />
            <span className="fw-bold" style={{ color: '#14263d', fontSize: 15, letterSpacing: '-0.02em' }}>
              Design Automation
            </span>
          </Link>

          {/* Toggler */}
          <button
            className="navbar-toggler border-0 shadow-none"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#landingNav"
            aria-controls="landingNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Links */}
          <div className="collapse navbar-collapse" id="landingNav">
            <ul className="navbar-nav ms-auto align-items-md-center gap-md-4 mt-3 mt-md-0">
              <li className="nav-item">
                <a href="#platform" className="nav-link px-0 fw-semibold" style={{ color: '#556579', fontSize: 13 }}>
                  Platform
                </a>
              </li>
              <li className="nav-item">
                <a href="#workflow" className="nav-link px-0 fw-semibold" style={{ color: '#556579', fontSize: 13 }}>
                  Workflow
                </a>
              </li>
              <li className="nav-item">
                <Link
                  to="/login"
                  className="btn btn-outline-primary d-inline-flex align-items-center gap-2 px-3 py-2"
                  style={{ borderColor: '#d6e0eb', color: '#193e6c', background: '#fff', borderRadius: 7, fontSize: 13, fontWeight: 600 }}
                >
                  Sign in <i className="bi bi-arrow-up-right" aria-hidden="true"></i>
                </Link>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>

    {/* ============ HERO ============ */}
    <section
      id="platform"
      className="border-bottom"
      style={{
        borderColor: '#e9eef4',
        background:
          'radial-gradient(ellipse at 78% 44%, rgba(219,232,247,0.68), transparent 41%), linear-gradient(112deg, #fff 0%, #f9fbfe 52%, #edf3fa 100%)',
      }}
    >
      <div className="container-xl py-5">
        <div className="row align-items-center g-5">
          {/* Copy */}
          <div className="col-12 col-lg-6">
            <span
              className="d-inline-flex align-items-center gap-2 fw-bold text-uppercase"
              style={{ color: '#63758b', fontSize: 10, letterSpacing: '0.16em' }}
            >
              <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#38a67a', boxShadow: '0 0 0 4px rgba(56,166,122,0.12)' }}></span>
              Engineering Workflow Platform
            </span>

            <h1
              className="mt-4 mb-3 fw-semibold"
              style={{ color: '#142b47', fontSize: 'clamp(38px, 4.5vw, 58px)', letterSpacing: '-0.05em', lineHeight: 1.1 }}
            >
              From station data<br />
              to <span style={{ color: '#246b8c' }}>ready-to-use</span><br />
              design documents.
            </h1>

            <p className="mb-0" style={{ maxWidth: 460, color: '#6b7b8e', fontSize: 15, lineHeight: 1.8 }}>
              A single workspace for managing station documents, coordinating verification,
              and generating design deliverables.
            </p>

            <div className="d-flex align-items-center flex-wrap gap-3 mt-4">
              <Link
                to="/login"
                className="btn btn-primary d-inline-flex align-items-center gap-2 px-3 py-2"
                style={{ background: '#193e6c', borderColor: '#193e6c', borderRadius: 7, fontSize: 13, fontWeight: 600 }}
              >
                Open your workspace <i className="bi bi-arrow-right" aria-hidden="true"></i>
              </Link>
              <span className="d-inline-flex align-items-center" style={{ color: '#748398', fontSize: 11 }}>
                <i className="bi bi-shield-check me-2" style={{ color: '#328f6b' }} aria-hidden="true"></i>
                Secure team access
              </span>
            </div>

            <div className="d-flex align-items-center gap-3 mt-5" style={{ color: '#8a98a8', fontSize: 9, fontWeight: 700, letterSpacing: '0.13em' }}>
              <span style={{ width: 32, height: 1, background: '#aebdcb' }}></span>
              <span>DESIGNED FOR COMPLEX RAILWAY PROJECTS</span>
            </div>
          </div>

          {/* Visual */}
          <div className="col-12 col-lg-6">
            <div className="position-relative d-flex align-items-center justify-content-center" style={{ minHeight: 380 }}>
              {/* Orbits */}
              <div className="position-absolute rounded-circle d-none d-sm-block" style={{ width: 400, height: 400, border: '1px solid rgba(76,119,158,0.12)' }}></div>
              <div className="position-absolute rounded-circle d-none d-sm-block" style={{ width: 310, height: 310, border: '1px solid rgba(76,119,158,0.12)' }}></div>
              <div className="position-absolute rounded-circle" style={{ width: 260, height: 260, background: 'rgba(193,218,241,0.46)', filter: 'blur(38px)' }}></div>

              {/* Blueprint Card */}
              <div
                className="position-relative bg-white border rounded-3 p-3 p-sm-4"
                style={{
                  width: 'min(390px, 92%)',
                  borderColor: 'rgba(210,222,235,0.9)',
                  boxShadow: '0 28px 70px rgba(34,62,92,0.16), 0 3px 8px rgba(34,62,92,0.06)',
                  transform: 'rotate(-2deg)',
                  zIndex: 1,
                }}
              >
                <div className="d-flex align-items-center justify-content-between" style={{ color: '#8897a8', fontSize: 8, fontWeight: 700, letterSpacing: '0.13em' }}>
                  <span>PROJECT WORKSPACE</span>
                  <i className="bi bi-three-dots" style={{ fontSize: 15 }} aria-hidden="true"></i>
                </div>

                <div className="d-flex align-items-center gap-3 my-3">
                  <span className="d-flex align-items-center justify-content-center rounded-2 flex-shrink-0" style={{ width: 41, height: 41, background: '#edf4fa', color: '#27648b', fontSize: 18 }}>
                    <i className="bi bi-diagram-3" aria-hidden="true"></i>
                  </span>
                  <div>
                    <strong className="d-block" style={{ color: '#1d3149', fontSize: 13 }}>Station design</strong>
                    <small className="d-block mt-1" style={{ color: '#8794a4', fontSize: 10 }}>Documents &amp; verification</small>
                  </div>
                </div>

                <hr className="my-2" style={{ borderColor: '#edf0f4', opacity: 1 }} />

                {[
                  { icon: 'bi-folder2-open', label: 'Input documents', badge: 'Ready', bg: '#eaf6ef', color: '#398263' },
                  { icon: 'bi-check2-square', label: 'Verification', badge: 'In review', bg: '#fff5e4', color: '#9a6b26' },
                  { icon: 'bi-file-earmark-text', label: 'Design outputs', badge: 'Versioned', bg: '#eaf6ef', color: '#398263' },
                ].map((row) => (
                  <div key={row.label} className="d-flex align-items-center justify-content-between py-2" style={{ color: '#516276', fontSize: 10 }}>
                    <span>
                      <i className={`bi ${row.icon} me-2`} style={{ color: '#6084a7', fontSize: 12 }} aria-hidden="true"></i>
                      {row.label}
                    </span>
                    <span className="badge rounded-1" style={{ background: row.bg, color: row.color, fontSize: 8, fontWeight: 600, padding: '4px 7px' }}>
                      {row.badge}
                    </span>
                  </div>
                ))}

                <div className="d-flex gap-1 my-3">
                  {[...Array(12)].map((_, i) => (
                    <span key={i} style={{ height: 4, flex: 1, borderRadius: 3, background: i < 9 ? '#74a7bc' : '#e6ecf2' }}></span>
                  ))}
                </div>

                <div className="d-flex align-items-center justify-content-between pt-3 border-top" style={{ color: '#78889a', fontSize: 9, borderColor: '#edf0f4' }}>
                  <span><i className="bi bi-clock-history me-2" style={{ color: '#547ca0' }} aria-hidden="true"></i>Revision history tracked</span>
                  <i className="bi bi-arrow-up-right" style={{ color: '#7292ad' }} aria-hidden="true"></i>
                </div>
              </div>

              {/* Float Card */}
              <div
                className="position-absolute d-none d-sm-flex align-items-center gap-3 bg-white border rounded-2 p-3"
                style={{ right: 0, bottom: 20, borderColor: '#e6ebf0', boxShadow: '0 12px 30px rgba(34,62,92,0.11)', zIndex: 2 }}
              >
                <span className="d-flex align-items-center justify-content-center rounded-2" style={{ width: 33, height: 33, background: '#fff6e8', color: '#b37b25' }}>
                  <i className="bi bi-lightning-charge-fill" aria-hidden="true"></i>
                </span>
                <div>
                  <strong className="d-block" style={{ color: '#273c53', fontSize: 10 }}>One connected workflow</strong>
                  <small className="d-block mt-1" style={{ color: '#8492a2', fontSize: 9 }}>Organize · Verify · Generate</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* ============ WORKFLOW ============ */}
    <section id="workflow" className="bg-white">
      <div className="container-xl py-5">
        <div className="d-flex align-items-baseline justify-content-between flex-wrap gap-2 mb-4">
          <span className="fw-bold text-uppercase" style={{ color: '#7b8b9d', fontSize: 9, letterSpacing: '0.16em' }}>
            One workspace, clear progress
          </span>
          <p className="mb-0" style={{ color: '#8592a1', fontSize: 11 }}>
            Keep every stage of station design connected.
          </p>
        </div>

        <div className="row g-0 border rounded-3 overflow-hidden" style={{ borderColor: '#e8edf3' }}>
          {[
            { num: '01', icon: 'bi-collection', title: 'Organize', desc: 'Keep station inputs and outputs together by version.' },
            { num: '02', icon: 'bi-patch-check', title: 'Verify', desc: 'Review records and revision history in context.' },
            { num: '03', icon: 'bi-file-earmark-arrow-down', title: 'Generate', desc: 'Create project documents from a guided workflow.' },
          ].map((step, i) => (
            <div
              key={step.num}
              className={`col-12 col-md-4 position-relative d-flex align-items-center gap-3 p-3 p-md-4 ${
                i > 0 ? 'border-top border-md-top-0 border-md-start' : ''
              }`}
              style={{ minHeight: 102, borderColor: '#e8edf3' }}
            >
              <span className="position-absolute fw-bold" style={{ top: 12, right: 16, color: '#aab5c1', fontSize: 8, letterSpacing: '0.08em' }}>
                {step.num}
              </span>
              <span className="d-flex align-items-center justify-content-center rounded-2 flex-shrink-0" style={{ width: 39, height: 39, background: '#edf4fa', color: '#27648b', fontSize: 16 }}>
                <i className={`bi ${step.icon}`} aria-hidden="true"></i>
              </span>
              <div>
                <h2 className="mb-1 fw-bold" style={{ color: '#20354e', fontSize: 12 }}>{step.title}</h2>
                <p className="mb-0" style={{ color: '#7d8b9a', fontSize: 10, lineHeight: 1.6, maxWidth: 220 }}>{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* ============ FOOTER ============ */}
    <footer className="bg-white border-top mt-auto" style={{ borderColor: '#edf0f4' }}>
      <div className="container-xl py-3">
        <div className="d-flex justify-content-between flex-wrap gap-2" style={{ color: '#929eab', fontSize: 9 }}>
          <span>© {new Date().getFullYear()} BHEPL Design Automation</span>
          <span>Project work, made more connected.</span>
        </div>
      </div>
    </footer>
  </main>
);

export default LandingScreen;